import api from "../api";

class loginService {
  async create(data) {
    return api.post("/DashBoard/Login", data);
  }
}

export default new loginService();